/** Maps backend category key to i18n translation key */
export const CATEGORY_I18N_MAP: Record<string, string> = {
  MICROPHONE: 'Feedback.categories.microphone',
  CAMERA: 'Feedback.categories.camera',
  SOUND_OUTPUT: 'Feedback.categories.sound',
  TOUCHSCREEN: 'Feedback.categories.touchscreen',
  APP_BLOCKED: 'Feedback.categories.appBlocked',
  CONNECTIVITY: 'Feedback.categories.connectivity',
  COMFORT: 'Feedback.categories.comfort',
  CLEANLINESS: 'Feedback.categories.cleanliness',
  OTHER: 'Feedback.categories.other',
};
